export const GET_RC_TICKET_LIST = 'GET_RC_TICKET_LIST'
export const STATUS_UPDATE = 'STATUS_UPDATE'